import { render, staticRenderFns } from "./UpsertCertificateTypeTemplate.vue?vue&type=template&id=be5dd5bc&scoped=true"
import script from "./UpsertCertificateTypeTemplate.vue?vue&type=script&lang=ts"
export * from "./UpsertCertificateTypeTemplate.vue?vue&type=script&lang=ts"
import style0 from "./UpsertCertificateTypeTemplate.vue?vue&type=style&index=0&id=be5dd5bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be5dd5bc",
  null
  
)

export default component.exports